import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './Section';
import './Education.css';

export function Education({ items }) {
  return (
    <Section id="education" title="Education">
      <div className="education-list">
        {items.map((edu, index) => (
          <motion.div
            key={edu.id}
            initial={{ x: -20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true, margin: '-100px' }}
            className="education-item"
          >
            <h4 className="education-degree">{edu.degree}</h4>
            <p className="education-institution">{edu.institution}</p>
            <p className="education-duration">{edu.duration}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
